<template>
  <div class="page">
    <section class="info-wrap">
      <el-form label-position="left" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px">
        <el-form-item label="互联网网站域名" prop="domain">
          <div class="style">
            <el-input v-model="ruleForm.domain" placeholder="" clearable></el-input>
          </div>
          <p class="labels-tips">如为PC端商城、智能终端等场景，可上传官网链接（格式需以http://或https://开头）；</p>
          <p class="labels-tips">网站域名需ICP备案，若备案主体与申请主体不同，请上传加盖公章的网站授权函。</p>
        </el-form-item>
        <el-form-item class="style" label="网站授权函">
          <div class="img-wrap">
            <div class="img-list">
              <el-upload
                :class="ruleForm.webAuthorisation && ruleForm.webAuthorisation.length > 0 ? 'hide' : ''"
                list-type="picture-card"
                :file-list="imgList"
                :action="$configUrl.uploadUrl"
                :on-remove="handleRemove"
                :on-success="
                  (response, file, fileList) => {
                    return webAuthorisationSuccess(file, fileList);
                  }
                "
              >
                <i class="el-icon-plus"></i>
              </el-upload>
              <div class="style"></div>
              <p class="labels-tips">若备案主体与申请主体不同，请务必上传加盖公章的网站授权函</p>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="互联网网站对应的商家APPID" prop="webAppid">
          <div class="style">
            <el-input v-model="ruleForm.webAppid" placeholder="" clearable></el-input>
          </div>
          <p class="labels-tips">
            可填写已认证的公众号、小程序、应用的APPID，其中公众号APPID需是已认证的服务号、政府或媒体类型的订阅号。
          </p>
        </el-form-item>
      </el-form>
    </section>
  </div>
</template>

<script>
export default {
  props: {
    count: {
      type: Number || Boolean,
      default: false,
    },
    allData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      imgList: [],
      ruleForm: {
        domain: '',
        webAuthorisation: '',
        webAppid: '',
      },
      rules: {
        domain: [{ required: true, message: '请输入互联网网站域名', trigger: ['blur', 'change'] }],
      },
    };
  },

  watch: {
    count: {
      handler: function () {
        this.validity();
      },
    },
    allData: {
      handler: function (data) {
        console.log(data);
        if (data.businessDataVO) {
          this.ruleForm = JSON.parse(JSON.stringify(data.businessDataVO));
          let webAuthorisationList = data.businessDataVO.webAuthorisation.split(',');
          this.imgList = webAuthorisationList.map((item) => {
            const fileItem = {
              name: 'file',
              url: item,
              response: {
                data: item,
              },
            };
            return fileItem;
          });
        }
      },
      immediate: true,
      deep: true,
    },
  },

  methods: {
    webAuthorisationSuccess(file, fileList) {
      console.log(file, fileList);
      this.ruleForm.webAuthorisation = file.response.data.url;
      console.log(this.ruleForm.webAuthorisation);
    },
    handleRemove() {
      this.ruleForm.webAuthorisation = '';
    },
    validity() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.$emit('confirm', { flag: true, ruleForm: this.ruleForm });
          console.log('验证通过');
        } else {
          this.$emit('confirm', { flag: false, ruleForm: this.ruleForm });
          console.log('验证失败');
          return false;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import '~@/assets/style/mixins.less';
@import '~@/assets/style/var.less';
.info-wrap {
  box-sizing: border-box;
  padding-left: 31px;
}
.img-wrap {
  width: 700px;
  .img-list {
    height: 80px;
    overflow: hidden;
  }
  .hint {
    font-size: 12px;
    transform-origin: left;
    transform: scale(0.9);
    color: #fe4b48;
    margin-bottom: 5px;
  }
  /deep/ .el-upload--picture-card {
    width: 58px;
    height: 58px;
    line-height: 58px;
  }
  /deep/ .el-upload-list {
    /deep/.el-upload-list__item.is-success:first-child {
      &::before {
        position: absolute;
        left: 0;
        top: 0;
        content: '主图';
        color: #fff;
        width: 100%;
        height: 22px;
        font-size: 12px;
        text-align: center;
        line-height: 22px;
        background: rgba(0, 0, 0, 0.36);
      }
    }
  }
  /deep/ .el-upload-list--picture-card .el-upload-list__item {
    width: 80px;
    height: 80px;
    box-sizing: border-box;
  }
  /deep/ .el-upload--picture-card i {
    font-size: 14px;
  }
  /deep/ .el-upload-list__item-actions {
    width: 80px;
    height: 80px;
  }
  .hide {
    /deep/ .el-upload.el-upload--picture-card {
      display: none;
    }
  }
}
.labels-tips {
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  color: #999999;
}
/deep/.el-input {
  width: 346px;
}
.style {
  margin-bottom: 7px;
}
</style>
